import { motion } from "framer-motion";
import React from "react";
import { BodyText } from "../../styles/global";
import {
  WrapperMainTwo,
  TitleText,
  LeftSection,
  RightSection,
} from "./Main.styles";

const bounceTransition = {
  y: {
    duration: 4,
    yoyo: Infinity,
    ease: "easeOut"
  }
}

export const MainSectionTwo = () => {
  return (
    <>
      <WrapperMainTwo>
        <LeftSection>
          <TitleText>
            <div>Hexa virtual accounts</div>
            <BodyText>
              <p className="hexaVirtualList">
                This is otherwise known as the Savings plan PIN (SP PIN) with
                these 6 unique PIN you get to activate your desired savings plan
              </p>
            </BodyText>
          </TitleText>
        </LeftSection>
        <RightSection>
          <motion.div transition={bounceTransition} animate={{ y: ["5%", "-5%"]}}>
            <img src="img/Hexa virtual account illustration.jpg" alt="" />
          </motion.div>
        </RightSection>
      </WrapperMainTwo>
    </>
  );
};
